import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

import { BootstrapSandboxService } from '@bootstrap/sandbox/bootstrap.sandbox.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    private readonly isAuthenticated$: Observable<boolean>;
    private readonly isTokenValid$: Observable<boolean>;

    constructor(
        private readonly router: Router,
        private readonly sandbox: BootstrapSandboxService,
        private readonly location: Location
    ) {
        this.isAuthenticated$ = this.sandbox.isAuthenticated$;
        this.isTokenValid$ = this.sandbox.isTokenValid$;
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.isTokenValid$.pipe(
            tap(isTokenValid => {
                if (!isTokenValid) {
                    this.sandbox.clearStore();
                }
            }),
            map(result => {
                if (!result) {
                    const loginUrlTree: UrlTree = this.router.parseUrl('/login');
                    loginUrlTree.queryParams = {
                        entryNavigationUrl: state.url
                    };

                    return loginUrlTree;
                }

                return result;
            })
        );
    }

    canMatch(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        return this.isAuthenticated$.pipe(
            take(1),
            map((isLoggedIn: boolean) => {
                if (!isLoggedIn) {
                    this.router.navigate(['/login'], {
                        queryParams: {
                            entryNavigationUrl: this.location.path().slice(1)
                        }
                    });
                }
                return isLoggedIn;
            })
        );
    }
}
